import {
  ArrayField,
  Datagrid,
  DateField,
  EditButton,
  Labeled,
  NumberField,
  ReferenceField,
  SelectField,
  Show,
  SimpleShowLayout,
  TextField,
  useShowController,
} from "react-admin";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { settings } from "app";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import BackButtonToolbar from "features/BackButtonToolbar";
import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import { SemestersChoices } from "utils/choices";
import StartRankingDialog from "./StartRankingDialog";
import { SectionTitle } from "features/SectionTitle";

const ShowCurriculumSelectionCampaign = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const { record } = useShowController();
  const today = new Date().toISOString().split("T")[0];
  const isApplicationPeriodOver = record?.applicationEndDate && today > record.applicationEndDate;

  return (
    <Show
      title="Детайли на кампания за избор на учебен план"
      actions={
        <BackButtonToolbar
          additionalButton={
            <EditButton
              variant="contained"
              size="medium"
            />
          }
        />
      }
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Основна информация"
          textAlign="center"
          paddingY={0}
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на кампанията">
              <TextField source="name" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Специалност">
              <ReferenceField
                source="specialityId"
                reference={administrationRequests.getSpecialitiesSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Семестър">
              <SelectField
                source="semester"
                choices={SemestersChoices}
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Начало на кандидатстването">
              <DateField
                source="applicationStartDate"
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Край на кандидатстването">
              <DateField
                source="applicationEndDate"
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
          {isApplicationPeriodOver && (
            <Grid
              item
              xs={12}
              md={4}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <SecuredComponent permission={permissions.canManageCurriculumSelectionCampaigns}>
                <StartRankingDialog campaignId={record?.id} />
              </SecuredComponent>
            </Grid>
          )}
        </Grid>
        <SectionTitle
          title="  Учебни планове за избор"
          textAlign="center"
          paddingY={0}
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <ArrayField
              source="options"
              label=""
            >
              <Datagrid
                bulkActionButtons={false}
                rowClick={false}
                sx={settings.style.detailsDatagrid}
              >
                <ReferenceField
                  source="curriculumId"
                  reference={studentRequests.getCurriculumsSelect()}
                  label="Учебен план"
                  sortable={false}
                >
                  <TextField source="name" />
                </ReferenceField>
                <NumberField
                  source="placesCount"
                  label="Брой места"
                  sortable={false}
                />
              </Datagrid>
            </ArrayField>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowCurriculumSelectionCampaign;
